import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);

  const phoneNumber = '919825218789';
  const defaultMessage = encodeURIComponent(
    "Hi ASCENT INTERNATIONAL! I'm interested in your signage services. Can you please provide more information?"
  );

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${defaultMessage}`;

  // Show tooltip after 5 seconds if user hasn't interacted
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!hasInteracted) {
        setIsTooltipVisible(true);
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, [hasInteracted]);

  const handleClick = () => {
    setHasInteracted(true);
    setIsTooltipVisible(false);
    window.open(whatsappUrl, '_blank');
  };

  const closeTooltip = (e) => {
    e.stopPropagation();
    setIsTooltipVisible(false);
    setHasInteracted(true);
  };

  return (
    <div className="fixed bottom-8 right-8 z-50" data-testid="whatsapp-button-container">
      {/* Tooltip */}
      <AnimatePresence>
        {isTooltipVisible && (
          <motion.div
            className="absolute bottom-full right-0 mb-3 w-64"
            initial={{ opacity: 0, y: 10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.95 }}
            transition={{ duration: 0.2 }}
          >
            <div className="bg-white rounded-xl p-4 shadow-2xl border border-gray-100 relative">
              <button
                onClick={closeTooltip}
                className="absolute -top-2 -right-2 w-6 h-6 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors"
                aria-label="Close tooltip"
              >
                <X className="w-3 h-3 text-gray-600" />
              </button>
              <p className="text-slate-700 text-sm font-['Manrope']">
                👋 Need help with signage? Chat with us on WhatsApp for instant quotes!
              </p>
              {/* Arrow */}
              <div className="absolute -bottom-2 right-6 w-4 h-4 bg-white border-r border-b border-gray-100 transform rotate-45"></div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* WhatsApp Button */}
      <motion.button
        onClick={handleClick}
        className="whatsapp-btn group"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        data-testid="whatsapp-btn"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="w-7 h-7 text-white fill-white" />
        
        {/* Pulse animation */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20"></span>
      </motion.button>
    </div>
  );
};

export default WhatsAppButton;
